import React, { memo } from 'react';
import * as S from './styles';
import type { Column } from '../../types';
import type { Page } from '../../../../globals/actions/types';
import { H3Text } from '@prisjakt/ui/text/variants';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

interface Props {
  columns: Column[];
}

const InfoPages = ({ columns }: Props) => (
  <>
    {columns.map((column: Column) => (
      <S.Column key={`column-${column.title}`}>
        <H3Text>{column.title}</H3Text>
        <S.InfoPagesList>
          {column.pages.map((page: Page) => {
            return (
              page && (
                <S.ListItem
                  key={`${page.title}-${page.id}`}
                  onClick={() =>
                    trackInternalNavigationClick({
                      scope: InternalNavigationScope.FOOTER_INFO_PAGES,
                      nextPage: page.pathName,
                    })
                  }
                >
                  <S.Link
                    container="a"
                    containerProps={{
                      href: page.pathName,
                      // These links are nofollow to avoid them getting too much of the internal
                      // pagerank (since they occur on every page).
                      rel: page.follow ? 'follow' : 'nofollow',
                    }}
                  >
                    {page.title}
                  </S.Link>
                </S.ListItem>
              )
            );
          })}
        </S.InfoPagesList>
      </S.Column>
    ))}
  </>
);

export default memo(InfoPages);
